define('view/controller/booking/datetime/slots/TimeSlotsView',['require','view/controller/booking/datetime/TimeDefaultView','view/controller/booking/datetime/slots/TimeSlotView'],function (require) {
	
	var TimeDefaultView = require('view/controller/booking/datetime/TimeDefaultView');
	var TimeSlotView = require('view/controller/booking/datetime/slots/TimeSlotView');

	/**
	 * Time slots composite view (container)
	 * 
	 * @class TimeSlotsView
	 */
	return TimeDefaultView.extend({
		
	    template: '#time_slots_view',
	    childView: TimeSlotView,
	    childViewContainer: '#sb_time_slots_container',
		collectionEvents: {
	    	'sync': 'render'
		},
        
        childEvents: {
            'select:time': 'onTimeSelected'
        },
        
        childViewOptions: function () {
            return _.extend({}, TimeDefaultView.prototype.childViewOptions.apply(this, arguments), {
                bookingModel: this.getOption('bookingModel')
            });
        },
        
        onTimeSelected: function (view, data) {
            var model = data.model;
            this.triggerMethod('timeChanged', model.get('time'), model.get('date'));
        }
	    
	});
	
});
